/**
 * Opacity Tokens - Opacity scale
 */
export const opacity = {
  // "outdated values which remain for the moment for backward compatibility"
  100: { value: '100%' },
  90: { value: '90%' },
  80: { value: '80%' },
  70: { value: '70%' },
  60: { value: '60%' },
  50: { value: '50%' },
  30: { value: '30%' },
  none: { value: '0%' },

  // Values by current Design System
  l: { value: '0.5' },
  m: { value: '0.2' },
  s: { value: '0.08' },
};
